var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3731",
    "data-name": "Group 3731",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3541",
    "data-name": "Rectangle 3541",
    width: 14,
    height: 20,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3730",
    "data-name": "Group 3730",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M13.307,6.187A7.191,7.191,0,0,0,11.4,2.1,6.235,6.235,0,0,0,5.374.14a6.133,6.133,0,0,0-2.816,1.4A7.2,7.2,0,0,0,.264,5.218,7.115,7.115,0,0,0,.1,8.285a9.469,9.469,0,0,0,1.3,3.379l1.237,2.024c1.012,1.657,2.059,3.37,3.085,5.056a1.479,1.479,0,0,0,.793.7l.021.007h.318l.021-.007a1.474,1.474,0,0,0,.794-.7c.45-.742.91-1.494,1.355-2.223.486-.794.989-1.616,1.479-2.426q.237-.39.476-.777c.484-.788.986-1.6,1.431-2.437a7.606,7.606,0,0,0,.9-4.7M12.286,7.64a6.435,6.435,0,0,1-.834,2.725c-.578,1.009-1.192,2.018-1.785,2.994l-.427.7c-.618,1.019-1.25,2.053-1.862,3.052l-.642,1.05c-.014.024-.03.049-.048.074l-.03-.047L5.614,16.484c-1.1-1.791-2.227-3.642-3.337-5.466a8.036,8.036,0,0,1-1.17-3.187,5.929,5.929,0,0,1,.234-2.488,6.006,6.006,0,0,1,2.091-3.07A5.1,5.1,0,0,1,5.907,1.211a6.466,6.466,0,0,1,.822-.054,5.271,5.271,0,0,1,4.286,2.2A5.977,5.977,0,0,1,12.286,7.64",
    transform: "translate(0.25 0.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    d: "M7.07,3.414H7.058a3.45,3.45,0,0,0-2.54,1.139,4.117,4.117,0,0,0-.008,5.52,3.454,3.454,0,0,0,2.551,1.143h0a3.457,3.457,0,0,0,2.553-1.146,4.033,4.033,0,0,0,1.056-2.76,3.775,3.775,0,0,0-3.6-3.9M9.61,7.321a2.852,2.852,0,0,1-.753,1.944,2.44,2.44,0,0,1-1.794.8H7.054A2.665,2.665,0,0,1,4.513,7.323,2.843,2.843,0,0,1,5.259,5.38a2.437,2.437,0,0,1,1.8-.816h0a2.435,2.435,0,0,1,1.8.812A2.84,2.84,0,0,1,9.61,7.321",
    transform: "translate(-0.123 0.115)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.5637c5103bc872ecf812e85f55e7d663.svg";
export { ForwardRef as ReactComponent };